
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class extends Vue {
  @Prop({ default: 3000 }) duration: number

  @Ref()
  bar: HTMLDivElement

  animationName: string = ''

  rafId: number = 0

  created(): void {}

  mounted(): void {
    if (!this.bar) return

    if (!this.animationName) {
      const style = window.getComputedStyle(this.bar)
      this.animationName = style.animationName
    }

    this.bar.style.animationName = 'none'
    this.bar.style.transform = 'translate3d(0,0,0)'

    this.rafId = window.requestAnimationFrame(() => {
      setTimeout(() => {
        if (!this.bar) return

        this.bar.style.animationName = this.animationName
        this.bar.style.animationDuration = `${this.duration}ms`
      }, 0)
    })
  }

  updated(): void {}

  destroyed(): void {}
}
